import { type LucideIcon } from 'lucide-react'
import { Card, CardContent } from '../ui/card'

interface MetricCardProps {
  title: string
  value: string | number
  icon: LucideIcon
}

export function MetricCard({ title, value, icon: Icon }: MetricCardProps) {
  return (
    <Card className='border-[#B87775]'>
      <CardContent className="flex items-center justify-between p-6">
        <div>
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <h3 className="text-2xl font-bold mt-1">{value}</h3>
        </div>
        <div className="text-[#B87775]">
          <Icon className="h-6 w-6" />
        </div>
      </CardContent>
    </Card>
  )
}